/**
 * The external dependencies.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Redirect, Route} from 'react-router-dom';
/**
 * The internal dependencies.
 */
import {isLoggedIn} from '../../store/auth/selectors';

const PrivateRoute = ({
                          component: Component,
                          loggedIn,
                          ...rest
                      }) => (
    <Route {...rest} render={(props) =>
        loggedIn ? (
            <Component {...props} />
        ) : (
            <Redirect
                to={{
                    pathname: '/login',
                    state: {from: props.location},
                }}
            />
        )
    }
    />
);

/**
 * Define the interface of the component.
 *
 * @type {Object}
 */
PrivateRoute.propTypes = {
    loggedIn: PropTypes.bool,
};

export default connect(
    (state) => ({
        loggedIn: isLoggedIn(state),
    })
)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/containers/private-route/index.js